import { createSelector } from 'reselect';
import { IStore } from 'store/interface';

export const getDialogs = createSelector(
  ({ dialog }: IStore) => dialog,
  dialog => Array.from(dialog.entries())
);
